import React, { Component, Suspense } from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom'
import TimeAgo from 'javascript-time-ago'

import en from 'javascript-time-ago/locale/en.json'
import ru from 'javascript-time-ago/locale/ru.json'
import './scss/style.scss'
import RequireAuth from './components/RequireAuth'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

TimeAgo.addDefaultLocale(en)
TimeAgo.addLocale(ru)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))
const ResetPassword = React.lazy(() => import('./views/pages/login/ResetPassword'))
const ForgotPassword = React.lazy(() => import('./views/pages/login/FogotPassword'))
const PasswordReset = React.lazy(() => import('./views/pages/login/PasswordReset'))
// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

class App extends Component {
  render() {
    return (
      <HashRouter>
        <Suspense fallback={loading}>
          <Routes>
            <Route exact path="/login" name="Login Page" element={<Login />} />
            {/* <Route exact path="/resetPassword" name="Login Page" element={<ResetPassword />} /> */}
            <Route
              exact
              path="/forgotPassword"
              name="Forgot Password"
              element={<ForgotPassword />}
            />
            <Route exact path="/passwordReset" name="Forgot Password" element={<PasswordReset />} />
            <Route exact path="/404" name="Page 404" element={<Page404 />} />
            <Route exact path="/500" name="Page 500" element={<Page500 />} />

            {/* we want to protect these routes */}
            <Route element={<RequireAuth allowedRoles={['administrator']} />}>
              <Route path="*" name="Home" element={<DefaultLayout />} />
            </Route>
          </Routes>
        </Suspense>
      </HashRouter>
    )
  }
}

export default App
